import { iProduct } from '@app/interfaces/IProduct';
import { StringifyOptions } from 'querystring';

export interface SubscriptionStatusResponse {
  activeSubscriptionImageUrl: string;
  activeSubscriptionThemeColor: string;
  currentMembershipUsage: number;
  hasActiveSubscription: boolean;
  hasSubscriptionQuota: boolean;
  maxMembershipQuota: number;
  remainders: object;
  subscriptionExtraDiscount: number;
  subscriptionMembershipId: string;
  subscriptionMessage: string;
  totalDaysToExpiration: string;
  totalPlanMemebershipQuota: number;
}

export interface SubscriptionResponse {
  items: Array<SubscriptionItemResponse>;
}
export interface SubscriptionItemResponse {
  subscriptionPlanId: string;
  title: string;
  identifier: number;
  totalQuotaDesc: string;
  planIconPath: string;
  intervalQuotaDesc: string;
  limits: any;
  product: iProduct;
  extraBooksDiscountDesc: string;
  intervalCost: number;
  durationMonths: number;
  description: string;
  durationDays: number;
  durationDesc: string;
  extraDescription: string;
  intervalDurationDesc: StringifyOptions;
  popularPlan: boolean;
  themeColor: string;
}

export interface SubscriptionStatus {
  totalDaysToExpiration?: number;
  isUnlimitedSubscription?: boolean
}

export enum SubscriptionStatusEnum {
  Not_YET_SUBSCRIPTION = 0,
  SUBSCRIPTION_EXPIRED = 1,
  OLD_SUBSCRIPTION = 2,
  NEW_SUBSCRIPTION = 3,
  NOT_LOGIN = 4
}
